import React from 'react'
import { Box, Typography, Link } from '@material-ui/core'
import { useTranslation } from 'react-i18next'

import helpers from 'helpers'
import styles from '../styles'

import useCookieBanner from 'hooks/useCookieBanner'

const ServiceChannelInfo = () => {
  const { t } = useTranslation()
  const { getBannerTextOverride, banner } = useCookieBanner()
  const classes = styles()

  const overrides = helpers.cookies.bannerTextOverride.getBannerLevel2Overrides(
    getBannerTextOverride,
  )

  const previewTexts = {
    title:
      overrides?.sections?.privacyPortal?.title || t('privacyPortal.title'),
    description:
      overrides?.sections?.privacyPortal?.description ||
      t('privacyPortal.description'),
  }

  return (
    <Box className={classes.container}>
      <Typography variant="h6" className={classes.title}>
        {previewTexts.title}
      </Typography>
      <Typography className={classes.description}>
        {previewTexts.description}
      </Typography>
      <Link
        href={banner?.privacyPortalUrl}
        target="_blank"
        rel="noopener"
        underline="none"
        width="fit-content"
        className={classes.linkPortal}
      >
        {previewTexts.title}
      </Link>
    </Box>
  )
}

export default ServiceChannelInfo
